export default class ProductPagesDataProvider {
  constructor(ProductPages) {
    "ngInject"
    this.ProductPagesService = ProductPages;
  }

  editor() {
    // Initialize
    tinymce.EditorManager.editors = [];
    tinymce.init({
      selector: '.tinymce',
      plugins: ['paste', 'link', 'autoresize']
    });
    tinymce.init({
      selector: '.full-tinymce',
      toolbar1: 'undo redo | insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
      toolbar2: 'print preview media | forecolor backcolor emoticons ',
      image_advtab: true,
      plugins: [
        'advlist autolink lists link image charmap print preview hr anchor pagebreak',
        'searchreplace visualblocks visualchars code fullscreen',
        'insertdatetime media nonbreaking save table contextmenu directionality',
        'paste textcolor colorpicker textpattern imagetools toc'
      ]
    })
  }

  getCategory(data, type) {
    return this.ProductPagesService.loadCategories(data)
      .then((categories) => {
        return categories;
      })
  }

  loadCategoriesNoLimit(parentId) {
    return this.ProductPagesService.loadCategoriesNoLimit(parentId)
      .then((categories) => {
        return categories;
      })
  }

  saveProductPage(data) {
    return this.ProductPagesService
      .saveProductPage(data)
      .then((resp) => {
        return resp;
      })
  }

  updateProductPage(data, type) {
    return this.ProductPagesService
      .updateProductPage(data, type)
      .then((resp) => {
        return resp;
      })
  }

  getProductPages(data, type) {
    return this.ProductPagesService.loadProductPages(data, type)
      .then((result) => {
        return result;
      })
  }

  getProductPage(id, type) {
    return this.ProductPagesService.getProductPage(id, type)
      .then((result) => {
        return result;
      })
  }

  getProductPageProducts(id, type) {
    return this.ProductPagesService.getProductPageProducts(id, type)
      .then((result) => {
        return result;
      })
  }

  saveCategory(data) {
    return this.ProductPagesService
      .saveCategory(data)
      .then((resp) => {
        return resp;
      })
  }

  updateCategoryOrder(data) {
    return this.ProductPagesService
      .updateCategoryOrder(data)
      .then((resp) => {
        return resp;
      })
  }

  updateProductPageOrder(data) {
    return this.ProductPagesService
      .updateProductPageOrder(data)
      .then((resp) => {
        return resp;
      })
  }

  removeCategory(id, type) {
    return this.ProductPagesService
      .removeCategory(id, type)
      .then((resp) => {
        return resp;
      })
  }

  getCategoryById(id) {
    return this.ProductPagesService.categoryById(id)
      .then((resp) => {
        return resp;
      })
  }

  updateCategory(data) {
    return this.ProductPagesService
      .updateCategory(data)
      .then((resp) => {
        return resp;
      })
  }

  getSubCategory(data) {
    return this.ProductPagesService.getSubCategory(data)
      .then((categories) => {
        return categories;
      })
  }

  updateProductPageStatus(data) {
    return this.ProductPagesService
      .updateProductPageStatus(data)
      .then((resp) => {
        return resp;
      })
  }

  removeProductPage(id) {
    return this.ProductPagesService
      .removeProductPage(id)
      .then((resp) => {
        return resp;
      })
  }

  removeProduct(id, apid) {
    return this.ProductPagesService
      .removeProduct(id, apid)
      .then((resp) => {
        return resp;
      })
  }


}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/product-page/services/products.pages.dataprovider.service.js
 **/